import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  privacy: string;

  constructor(private db: DbService) {}

  ngOnInit() {
    this.getData();
  }

  // 약관 데이터에 대해서 가져오기
  async getData() {
    let admin = await this.db.toDoc$(`admin/terms`);
    this.privacy = admin.personal;
  }
}
